import { render } from "./InputHousenumber.vue?vue&type=template&id=42bf3244&scoped=true"
import script from "./InputHousenumber.vue?vue&type=script&lang=js"
export * from "./InputHousenumber.vue?vue&type=script&lang=js"

import "./InputHousenumber.vue?vue&type=style&index=0&id=42bf3244&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bf3244"]])

export default __exports__